import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import clsx from 'clsx'

interface Props {
  defaultValue?: string
  autoFocus?: boolean
  className?: string
}

export default function SearchBox({ defaultValue = '', autoFocus = false, className }: Props) {
  const [query, setQuery] = useState(defaultValue)
  const navigate = useNavigate()

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    const q = query.trim()
    if (q) navigate(`/suche?q=${encodeURIComponent(q)}`)
  }

  return (
    <form
      onSubmit={handleSubmit}
      className={clsx(
        'flex max-w-[520px] w-full bg-white border border-gray-200 rounded-xl overflow-hidden',
        'transition-all focus-within:border-fom-500 focus-within:ring-[3px] focus-within:ring-fom-500/10',
        className,
      )}
    >
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Firmenname oder Accountnummer eingeben …"
        autoFocus={autoFocus}
        autoComplete="off"
        className="flex-1 px-4 py-2.5 text-[0.9rem] border-none outline-none bg-transparent text-gray-900 placeholder:text-gray-300"
      />
      <button
        type="submit"
        className="px-6 py-2.5 bg-fom-500 text-white text-[0.82rem] font-semibold border-none cursor-pointer transition-colors hover:bg-fom-600"
      >
        Suchen
      </button>
    </form>
  )
}
